/**
 * Allows alterations on the config to send to oewa implementation. Alterations supported are based on path and user.
 */

import { UserContextInterface } from '~/jobiqo/context/user';
import { PathContextInterface } from '~/jobiqo/models/app';

/**
 * Allows alterations on the config to send to oewa implementation. Alterations supported are based on path and user.
 *
 * @param configData
 *  The config data to be sent to oewa.
 * @param pageData
 *  The page data to be sent to oewa.
 * @param pathContext
 *  The path context.
 * @param userContext
 *  The user context.
 *
 * @returns The altered config data and page data.
 */
export function alterOewaConfigData(
  configData: any,
  pageData: any,
  pathContext: PathContextInterface,
  userContext: UserContextInterface,
) {
  return {
    configData,
    pageData,
  };
}
